import { EventCategoryEnum } from 'api/events/events.enum';

export const EventCategoryDescriptionEnum: Record<EventCategoryEnum, string> = {
  [EventCategoryEnum.NIEUPRAWNIONA]: 'events.other.category.unauthorized',
  [EventCategoryEnum.NIEWYDANA]: 'events.other.category.notIssued',
  [EventCategoryEnum.OBCA]: 'events.other.category.foreign',
};
